import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=3d8e1b40"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8e1b40')) {
      api.createRecord('3d8e1b40', component.options)
    } else {
      api.reload('3d8e1b40', component.options)
    }
    module.hot.accept("./Pago.vue?vue&type=template&id=3d8e1b40", function () {
      api.rerender('3d8e1b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Pago.vue"
export default component.exports